import { LocalDate } from '@js-joda/core';

import { BindingCreator } from '@dreryk/react-common';
import { DatePicker, StyledMaxWidth } from '@dreryk/react-components';

import { gynecologicalInterviewTranslationKeys } from '../../../translations';

const PREDICTED_COMPLETION_DATE_FIELD_NAME = 'predictedCompletionDate';

type GynecologicalInterviewPredictedCompletionDateFormBeanPart = {
   [PREDICTED_COMPLETION_DATE_FIELD_NAME]: LocalDate | null;
};

type GynecologicalInterviewPredictedCompletionDateDatePickerProps = {
   readonly register: BindingCreator<
      GynecologicalInterviewPredictedCompletionDateFormBeanPart,
      'predictedCompletionDate'
   >;
};

export const GynecologicalInterviewPredictedCompletionDateDatePicker = (
   props: GynecologicalInterviewPredictedCompletionDateDatePickerProps
): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={184}>
         <DatePicker
            testId={'predictedCompletionDate'}
            controller={props.register('predictedCompletionDate')}
            label={gynecologicalInterviewTranslationKeys.predictedCompletionDate}
            dayValidators={'dayBeforeToday'}
         />
      </StyledMaxWidth>
   );
};
